import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyTokens = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 224 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			opacity: .6,
			filter: "url(#filter0_d_1497_5197)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "path-1-inside-1_1497_5197",
					fill: "white",
					children: /* @__PURE__ */ _jsx("path", { d: "M91.9658 16.3934C93.0488 16.1761 94.1029 16.8779 94.3201 17.9609L107.695 84.6325C107.913 85.7155 107.211 86.7696 106.128 86.9869L23.7688 103.509C22.6858 103.726 21.6317 103.025 21.4145 101.942L8.03924 35.2701C7.82198 34.1871 8.52379 33.133 9.60678 32.9157L91.9658 16.3934Z" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M91.9658 16.3934C93.0488 16.1761 94.1029 16.8779 94.3201 17.9609L107.695 84.6325C107.913 85.7155 107.211 86.7696 106.128 86.9869L23.7688 103.509C22.6858 103.726 21.6317 103.025 21.4145 101.942L8.03924 35.2701C7.82198 34.1871 8.52379 33.133 9.60678 32.9157L91.9658 16.3934Z",
					fill: "var(--token-color-bg-subtle)",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M94.3201 17.9609L93.3397 18.1576L106.715 84.8292L107.695 84.6325L108.676 84.4358L95.3006 17.7642L94.3201 17.9609ZM106.128 86.9869L105.931 86.0064L23.5721 102.529L23.7688 103.509L23.9655 104.49L106.325 87.9673L106.128 86.9869ZM21.4145 101.942L22.3949 101.745L9.01971 35.0734L8.03924 35.2701L7.05878 35.4667L20.434 102.138L21.4145 101.942ZM9.60678 32.9157L9.80348 33.8962L92.1625 17.3739L91.9658 16.3934L91.7691 15.4129L9.41009 31.9353L9.60678 32.9157ZM8.03924 35.2701L9.01971 35.0734C8.91108 34.5319 9.26198 34.0048 9.80348 33.8962L9.60678 32.9157L9.41009 31.9353C7.7856 32.2612 6.73288 33.8423 7.05878 35.4667L8.03924 35.2701ZM23.7688 103.509L23.5721 102.529C23.0306 102.637 22.5036 102.286 22.3949 101.745L21.4145 101.942L20.434 102.138C20.7599 103.763 22.341 104.816 23.9655 104.49L23.7688 103.509ZM107.695 84.6325L106.715 84.8292C106.824 85.3707 106.473 85.8978 105.931 86.0064L106.128 86.9869L106.325 87.9673C107.949 87.6414 109.002 86.0603 108.676 84.4358L107.695 84.6325ZM94.3201 17.9609L95.3006 17.7642C94.9747 16.1397 93.3936 15.087 91.7691 15.4129L91.9658 16.3934L92.1625 17.3739C92.704 17.2652 93.2311 17.6161 93.3397 18.1576L94.3201 17.9609Z",
					fill: "var(--token-color-border)",
					mask: "url(#path-1-inside-1_1497_5197)"
				}),
				/* @__PURE__ */ _jsx("g", {
					clipPath: "url(#clip0_1497_5197)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M63.0417 61.995L59.365 62.7326L58.9856 60.8417L57.9439 61.0507C57.5733 62.6987 56.2436 64.0145 54.5891 64.3464C52.1992 64.8259 49.9076 63.253 49.4144 60.7949C48.9213 58.3367 50.4289 56.0017 52.8188 55.5222C54.4734 55.1903 56.2077 55.8914 57.1852 57.2689L63.7421 55.9535L64.5007 59.7353L62.6624 60.1041L63.0417 61.995ZM60.3376 61.2262L61.5632 60.9803L61.1839 59.0894L63.0223 58.7206L62.7694 57.46L56.5802 58.7016L56.3691 58.285C55.6873 57.1105 54.3586 56.5247 53.0717 56.7828C51.3559 57.127 50.286 58.7842 50.64 60.549C50.9941 62.3138 52.6204 63.43 54.3362 63.0858C55.623 62.8277 56.623 61.7747 56.799 60.428L56.8331 59.9622L59.9583 59.3353L60.3376 61.2262ZM54.0833 61.8252C53.0416 62.0342 52.0805 61.3746 51.8656 60.3031C51.6506 59.2316 52.2829 58.2524 53.3246 58.0434C54.3664 57.8344 55.3274 58.494 55.5423 59.5655C55.7573 60.637 55.125 61.6162 54.0833 61.8252ZM53.5775 59.304C53.2098 59.3778 53.0153 59.6791 53.0912 60.0573C53.167 60.4354 53.4627 60.6384 53.8304 60.5646C54.1981 60.4909 54.3926 60.1896 54.3167 59.8114C54.2409 59.4332 53.9452 59.2303 53.5775 59.304Z",
						fill: "var(--token-color-border)"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .6,
			filter: "url(#filter1_d_1497_5197)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "path-4-inside-2_1497_5197",
					fill: "white",
					children: /* @__PURE__ */ _jsx("path", { d: "M131.769 16.3934C130.686 16.1761 129.632 16.8779 129.415 17.9609L116.039 84.6325C115.822 85.7155 116.524 86.7696 117.607 86.9869L199.966 103.509C201.049 103.726 202.103 103.025 202.32 101.942L215.696 35.2701C215.913 34.1871 215.211 33.133 214.128 32.9157L131.769 16.3934Z" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M131.769 16.3934C130.686 16.1761 129.632 16.8779 129.415 17.9609L116.039 84.6325C115.822 85.7155 116.524 86.7696 117.607 86.9869L199.966 103.509C201.049 103.726 202.103 103.025 202.32 101.942L215.696 35.2701C215.913 34.1871 215.211 33.133 214.128 32.9157L131.769 16.3934Z",
					fill: "var(--token-color-bg-subtle)",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M129.415 17.9609L130.395 18.1576L117.02 84.8292L116.039 84.6325L115.059 84.4358L128.434 17.7642L129.415 17.9609ZM117.607 86.9869L117.804 86.0064L200.163 102.529L199.966 103.509L199.769 104.49L117.41 87.9673L117.607 86.9869ZM202.32 101.942L201.34 101.745L214.715 35.0734L215.696 35.2701L216.676 35.4667L203.301 102.138L202.32 101.942ZM214.128 32.9157L213.931 33.8962L131.572 17.3739L131.769 16.3934L131.966 15.4129L214.325 31.9353L214.128 32.9157ZM215.696 35.2701L214.715 35.0734C214.824 34.5319 214.473 34.0048 213.931 33.8962L214.128 32.9157L214.325 31.9353C215.949 32.2612 217.002 33.8423 216.676 35.4667L215.696 35.2701ZM199.966 103.509L200.163 102.529C200.704 102.637 201.231 102.286 201.34 101.745L202.32 101.942L203.301 102.138C202.975 103.763 201.394 104.816 199.769 104.49L199.966 103.509ZM116.039 84.6325L117.02 84.8292C116.911 85.3707 117.262 85.8978 117.804 86.0064L117.607 86.9869L117.41 87.9673C115.786 87.6414 114.733 86.0603 115.059 84.4358L116.039 84.6325ZM129.415 17.9609L128.434 17.7642C128.76 16.1397 130.341 15.087 131.966 15.4129L131.769 16.3934L131.572 17.3739C131.031 17.2652 130.504 17.6161 130.395 18.1576L129.415 17.9609Z",
					fill: "var(--token-color-border)",
					mask: "url(#path-4-inside-2_1497_5197)"
				}),
				/* @__PURE__ */ _jsx("g", {
					clipPath: "url(#clip1_1497_5197)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M160.115 62.5717L163.791 63.3093L164.171 61.4184L165.212 61.6274C165.583 63.2753 166.913 64.5911 168.567 64.9231C170.957 65.4025 173.249 63.8297 173.742 61.3715C174.235 58.9134 172.727 56.5783 170.337 56.0989C168.683 55.767 166.949 56.4681 165.971 57.8456L159.414 56.5302L158.656 60.312L160.494 60.6808L160.115 62.5717ZM162.819 61.8028L161.593 61.557L161.972 59.6661L160.134 59.2973L160.387 58.0367L166.576 59.2783L166.787 58.8617C167.469 57.6871 168.798 57.1013 170.085 57.3595C171.8 57.7037 172.87 59.3608 172.516 61.1257C172.162 62.8905 170.536 64.0067 168.82 63.6625C167.533 63.4043 166.533 62.3513 166.357 61.0047L166.323 60.5389L163.198 59.9119L162.819 61.8028ZM169.073 62.4019C170.115 62.6109 171.076 61.9513 171.291 60.8798C171.506 59.8083 170.873 58.8291 169.832 58.6201C168.79 58.4111 167.829 59.0707 167.614 60.1422C167.399 61.2137 168.031 62.1929 169.073 62.4019ZM169.579 59.8807C169.946 59.9544 170.141 60.2557 170.065 60.6339C169.989 61.0121 169.694 61.215 169.326 61.1413C168.958 61.0675 168.764 60.7662 168.84 60.388C168.915 60.0099 169.211 59.8069 169.579 59.8807Z",
						fill: "var(--token-color-border)"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_d_1497_5197)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "path-7-inside-3_1497_5197",
					fill: "white",
					children: /* @__PURE__ */ _jsx("path", { d: "M153.646 32C154.751 32 155.646 32.8954 155.646 34V102C155.646 103.105 154.751 104 153.646 104H69.646C68.5414 104 67.646 103.105 67.646 102V34C67.646 32.8954 68.5414 32 69.646 32H153.646Z" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M153.646 32C154.751 32 155.646 32.8954 155.646 34V102C155.646 103.105 154.751 104 153.646 104H69.646C68.5414 104 67.646 103.105 67.646 102V34C67.646 32.8954 68.5414 32 69.646 32H153.646Z",
					fill: "var(--token-color-bg)",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M155.646 34H154.646V102H155.646H156.646V34H155.646ZM153.646 104V103H69.646V104V105H153.646V104ZM67.646 102H68.646V34H67.646H66.646V102H67.646ZM69.646 32V33H153.646V32V31H69.646V32ZM67.646 34H68.646C68.646 33.4477 69.0937 33 69.646 33V32V31C67.9891 31 66.646 32.3431 66.646 34H67.646ZM69.646 104V103C69.0937 103 68.646 102.552 68.646 102H67.646H66.646C66.646 103.657 67.9891 105 69.646 105V104ZM155.646 102H154.646C154.646 102.552 154.198 103 153.646 103V104V105C155.303 105 156.646 103.657 156.646 102H155.646ZM155.646 34H156.646C156.646 32.3431 155.303 31 153.646 31V32V33C154.198 33 154.646 33.4477 154.646 34H155.646Z",
					fill: "var(--token-color-border)",
					mask: "url(#path-7-inside-3_1497_5197)"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .6,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M119.146 73.1429H114.146V70.5714H112.729C111.813 72.6286 109.729 74 107.479 74C104.229 74 101.646 71.3429 101.646 68C101.646 64.6571 104.229 62 107.479 62C109.729 62 111.813 63.3714 112.729 65.4286H121.646V70.5714H119.146V73.1429ZM115.813 71.4286H117.479V68.8571H119.979V67.1429H111.563L111.396 66.5429C110.813 64.8286 109.229 63.7143 107.479 63.7143C105.146 63.7143 103.313 65.6 103.313 68C103.313 70.4 105.146 72.2857 107.479 72.2857C109.229 72.2857 110.813 71.1714 111.396 69.4571L111.563 68.8571H115.813V71.4286ZM107.479 70.5714C106.063 70.5714 104.979 69.4571 104.979 68C104.979 66.5429 106.063 65.4286 107.479 65.4286C108.896 65.4286 109.979 66.5429 109.979 68C109.979 69.4571 108.896 70.5714 107.479 70.5714ZM107.479 67.1429C106.979 67.1429 106.646 67.4857 106.646 68C106.646 68.5143 106.979 68.8571 107.479 68.8571C107.979 68.8571 108.313 68.5143 108.313 68C108.313 67.4857 107.979 67.1429 107.479 67.1429Z",
						fill: "var(--token-color-accent)"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_1497_5197",
				x: -.354004,
				y: 10,
				width: 116.443,
				height: 103.903,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1497_5197"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1497_5197",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_1497_5197",
				x: 107.646,
				y: 10,
				width: 116.443,
				height: 103.903,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1497_5197"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1497_5197",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_1497_5197",
				x: 59.646,
				y: 26,
				width: 104,
				height: 88,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1497_5197"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1497_5197",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_1497_5197",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 28,
					height: 28,
					fill: "white",
					transform: "translate(68.8403 43.4711) rotate(78.6563)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_1497_5197",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 28,
					height: 28,
					fill: "white",
					transform: "matrix(-0.196695 0.980465 0.980465 0.196695 154.895 43.4711)"
				})
			})
		] })
	]
});
export default SvgEmptyTokens;
